const STORAGE_KEY = "stored-user-v2";

export class UserInfo {
    /**
     * 
     * @param {String} username 
     * @param {String[]} permissions 
     */
    constructor(username, permissions) {
        this.username = username;
        this.permissions = permissions ?? [];
    }
}
export default class UserService {
    constructor() { }

    /**
     * @returns {UserInfo}
     */
    getLoggedInUser() {
        let json = localStorage.getItem(STORAGE_KEY);

        if (!json) {
            return null;
        }
        let userRaw = JSON.parse(json);

        return new UserInfo(userRaw.username, userRaw.permissions);
    }

    /**
     * 
     * @param {String} username 
     * @param {String[]} permissions
     */
    setLoggedInUser(username, permissions) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(new UserInfo(username, permissions)));
    }

    /**
     * 
     */
    clearUser() {
        localStorage.removeItem(STORAGE_KEY);
    }
}